<script setup lang="ts">
import ProductDetail from '@src/product/components/product-detail.vue';
import VerticalAlignChildrenWrapper from '@components/layout-wrapper/vertical-align-children-wrapper.vue';
import ReservationDetail from '@src/warehouse/components/reservation-detail.vue';
import ProductSiblings from '@src/product/components/product-siblings.vue';
import { ItemInfoProps } from '@components/composables/item-info-composable.ts';
import WarehouseBinDetail from '@src/warehouse/components/warehouse-bin-detail.vue';

const props = defineProps<ItemInfoProps>();
</script>

<template>
    <VerticalAlignChildrenWrapper gap-bottom="2" avoid-outer-gap>
        <ProductDetail v-bind="props"/>
        <WarehouseBinDetail v-if="idBin" :id-bin="idBin"/>
        <ReservationDetail v-if="serials && serials.length > 0" v-bind="props"/>
        <ProductSiblings v-bind="props"/>
    </VerticalAlignChildrenWrapper>
</template>
